import { createSafeContext } from '@mews/framework';
import type { RepositoryRegistry } from '../createRegistry';

const { RepositoryRegistryContextProvider, useRepositoryRegistryContext } = createSafeContext<
    'RepositoryRegistryContext',
    RepositoryRegistry
>('RepositoryRegistryContext');

export const createRepositoryRegistryProvider =
    <P,>(repositoryRegistry: RepositoryRegistry) =>
    (props: P) => <RepositoryRegistryContextProvider value={repositoryRegistry} {...props} />;

/**
 * @deprecated
 * This should only be used internally in the data-access package.
 * Use ready-made hooks instead: useRepositoryQuery, useRepositoryMutation, etc.
 */
export const useRepositoryRegistry: () => RepositoryRegistry = useRepositoryRegistryContext;
